export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: { boxWidth: 12, padding: 15, font: { size: 11 } }
    }
  },
  scales: {
    y: {
      type: 'linear',
      display: true,
      position: 'left',
      beginAtZero: true,
      grid: { display: false },
      title: { display: true, text: 'Orders' }
    },
    y1: {
      type: 'linear',
      display: true,
      position: 'right',
      beginAtZero: true,
      grid: { display: false },
      title: { display: true, text: 'Revenue (₹)' }
    },
    y2: {
      type: 'linear',
      display: false,
      position: 'right',
      beginAtZero: true,
      grid: { display: false }
    },
    x: { grid: { display: false } }
  }
};

export const pieOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    y: { beginAtZero: true, grid: { display: false } },
    x: { grid: { display: false } }
  }
};

export const getCompareYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [
    { value: currentYear - 1, label: `Compare ${currentYear - 1}` },
    { value: currentYear - 2, label: `Compare ${currentYear - 2}` },
    { value: currentYear - 3, label: `Compare ${currentYear - 3}` }
  ];
};